"use client";

import { c as _c } from "react/compiler-runtime";
import { useState } from "react";
import type { ProfileData } from "../types";
import EditProfileTab from "./EditProfileTab";
import EditPasswordTab from "./EditPasswordTab";
import ChangeAvatarTab from "./ChangeAvatarTab";
import DeleteAccountSection from "./DeleteAccountSection";
import ConsentSettings from "./ConsentSettings";
import { Loader2, LogOut } from "lucide-react";
import { PillToggle } from "@/components/ui/controls/PillToggle";
type SubTab = "profile" | "password" | "avatar";
interface SettingsTabProps {
  profileData: ProfileData;
  onSave: (data: {
    name: string;
    email: string;
    nickname: string;
    countryId: string;
    gender: string;
  }) => Promise<void>;
  onPasswordChange: (passwords: {
    currentPassword: string;
    newPassword: string;
    confirmPassword: string;
  }) => Promise<void>;
  onAvatarChanged: () => Promise<void>;
  onSignOut: () => Promise<void>;
  labels: Record<string, string>;
  basePath: string;
}
const SUB_TABS: Array<{
  id: SubTab;
  labelKey: string;
  fallback: string;
}> = [{
  id: "profile",
  labelKey: "editProfile",
  fallback: "Edit Profile"
}, {
  id: "password",
  labelKey: "editPassword",
  fallback: "Change Password"
}, {
  id: "avatar",
  labelKey: "changeAvatar",
  fallback: "Change Avatar"
}];
export default function SettingsTab(t0) {
  const $ = _c(29);
  const {
    profileData,
    onSave,
    onPasswordChange,
    onAvatarChanged,
    onSignOut,
    labels,
    basePath
  } = t0;
  const [activeSubTab, setActiveSubTab] = useState("profile");
  const [isSigningOut, setIsSigningOut] = useState(false);
  let t1;
  if ($[0] !== onSignOut) {
    t1 = async () => {
      setIsSigningOut(true);
      try {
        await onSignOut();
      } catch {
        setIsSigningOut(false);
      }
    };
    $[0] = onSignOut;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleSignOut = t1;
  let t2;
  if ($[2] !== labels) {
    t2 = SUB_TABS.map(tab => ({
      id: tab.id,
      label: labels[tab.labelKey] || tab.fallback
    }));
    $[2] = labels;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== activeSubTab || $[5] !== t2) {
    t3 = <PillToggle options={t2} activeId={activeSubTab} onChange={setActiveSubTab} size="md" />;
    $[4] = activeSubTab;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== activeSubTab || $[8] !== basePath || $[9] !== handleSignOut || $[10] !== isSigningOut || $[11] !== labels || $[12] !== onSave || $[13] !== profileData) {
    t4 = activeSubTab === "profile" && <div className="space-y-8"><EditProfileTab profileData={profileData} onSave={onSave} labels={labels} /><hr className="border-border" /><div className="rounded-lg border border-border bg-card p-6"><div className="flex items-center justify-between"><div><h3 className="font-medium text-foreground">{labels.signOut || "Sign Out"}</h3><p className="text-sm text-muted-foreground">{labels.signOutDescription || "Sign out of your account on this device"}</p></div><button onClick={handleSignOut} disabled={isSigningOut} className="flex items-center gap-2 rounded-lg bg-secondary px-4 py-2 text-sm font-medium text-secondary-foreground transition hover:bg-secondary/80 cursor-pointer disabled:cursor-not-allowed disabled:opacity-50">{isSigningOut ? <Loader2 className="h-4 w-4 animate-spin" /> : <LogOut className="h-4 w-4" />}{isSigningOut ? labels.signingOut || "Signing out..." : labels.signOut || "Sign Out"}</button></div></div><ConsentSettings basePath={basePath} /><DeleteAccountSection labels={labels} basePath={basePath} /></div>;
    $[7] = activeSubTab;
    $[8] = basePath;
    $[9] = handleSignOut;
    $[10] = isSigningOut;
    $[11] = labels;
    $[12] = onSave;
    $[13] = profileData;
    $[14] = t4;
  } else {
    t4 = $[14];
  }
  let t5;
  if ($[15] !== activeSubTab || $[16] !== labels || $[17] !== onPasswordChange) {
    t5 = activeSubTab === "password" && <EditPasswordTab onPasswordChange={onPasswordChange} labels={labels} />;
    $[15] = activeSubTab;
    $[16] = labels;
    $[17] = onPasswordChange;
    $[18] = t5;
  } else {
    t5 = $[18];
  }
  let t6;
  if ($[19] !== activeSubTab || $[20] !== labels || $[21] !== onAvatarChanged || $[22] !== profileData) {
    t6 = activeSubTab === "avatar" && <ChangeAvatarTab profileData={profileData} onAvatarChanged={onAvatarChanged} labels={labels} />;
    $[19] = activeSubTab;
    $[20] = labels;
    $[21] = onAvatarChanged;
    $[22] = profileData;
    $[23] = t6;
  } else {
    t6 = $[23];
  }
  let t7;
  if ($[24] !== t3 || $[25] !== t4 || $[26] !== t5 || $[27] !== t6) {
    t7 = <div className="space-y-6">{t3}{t4}{t5}{t6}</div>;
    $[24] = t3;
    $[25] = t4;
    $[26] = t5;
    $[27] = t6;
    $[28] = t7;
  } else {
    t7 = $[28];
  }
  return t7;
}